<template>
  <tkui-header class="sol_header">
    <tk-flex
      slot="left"
      class="sole_header_left"
      middle
      :gutter="6"
    >
      <tk-image
        :width="28"
        :height="23"
        :src="require('@/assets/image/splash_logo.png')"
      ></tk-image>
      <tk-flex column>
        <div class="sole_header_left_top font-14">SOLESTAGE</div>
        <div class="sole_header_left_bottom">{{ lang.common.left_text }}</div>
      </tk-flex>
    </tk-flex>
    <tkui-button
      slot="right"
      class="slot_header_right"
      @click.native="downloadApp"
    >
      {{ lang.common.right_btn }}
    </tkui-button>
    <div id='guideZfbPayPage' style="display: none;" >
      <div class="wx-open" >
          <p>{{ lang.common.openTitle }}</p>
          <p>{{ lang.common.openTitleSecond }}</p>
      </div>
      <div class="triangle"></div>
    </div>
  </tkui-header>
</template>

<script>
import en from '../en'
import cn from '../cn'
import '@/assets/fonts/text.scss'
import { openApp } from '../js/callApp'
export default {
  props: {
    type: {
      type: String,
      default: 'dev'
    },
    langType: {
      type: String,
      default: 'en'
    },
    path: {
      type: String,
      default: ''
    },
    param: {
      type: Object
    }
  },
  data () {
    return {
      lang: en
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.lang = this.langType === 'en' ? en : cn
    },
    downloadApp () {
      openApp(this.type, this.langType, this.path, this.param)
    }
  }
}
</script>

<style lang="scss" scoped>
.sol_header {
  background-color: #060A13 !important;
  min-height: 56px !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  .sole_header_left_top {
    color: #fff;
    font-family: BeVie-Regular;
    font-weight: 400;
  }
  .sole_header_left_bottom {
    color: #84888F;
    font-family: BeVie-Regular;
    font-weight: 400;
    font-size: 11px;
  }
  .slot_header_right {
    color: #fff;
    font-family: BeVie-Regular;
    font-weight: 400;
    font-size: 14px;
    height: 32px;
    background: #F6313F;
    border-radius: 6px;
    margin: 0;
    min-width: 0;
  }
}

 /* 提示浏览器打开 */
 #guideZfbPayPage {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 777;
}
.wx-open {
    position: absolute;
    top: 16px;
    right: 15px;
    z-index: 888888;
    background-color: #F6313F;
    border-radius: 4px;
    padding: 8px;
}
.triangle {
    position: absolute;
    top: 0px;
    right: 30px;
    border-width: 8px;
    border-style: solid;
    border-color: transparent transparent #F6313F transparent;
    z-index: 888888;

}
.wx-open p {
    color: white;
    font-weight: 300;
    font-family: BeVie-Light;
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 0;
    text-align: center;
}

</style>
